module.exports = __webpack_public_path__ + "bf59c68.ttf";